module.exports = "https://static.wmbcdn.com/uniweb/images/5783734f1442548ae70e4e12c013585a.svg";